import {type DefaultError, useMutation} from "@tanstack/react-query";
import type {UrlMutationVariables} from "../../../query/queryClient";
import {queryHttp} from "../../../query/queryHttp";
import {environment} from "../../../env";
import {CHAT_CONFIG} from "../services/ChatConfiguration";

export type DeleteSessionVariables = {
    sessionId: string;
    appName: string;
};

export type DeleteSessionResponse = {
    message: string;
};

function deleteSessionMutationVariables({
                                            sessionId,
                                            appName,
                                        }: DeleteSessionVariables): UrlMutationVariables {
    if (!CHAT_CONFIG.API_URL && !environment.isTestChat) {
        throw new Error("Chat API URL is not configured");
    }

    return {
        url: `${CHAT_CONFIG.API_URL}/sessions/${encodeURIComponent(sessionId)}`,
        method: "DELETE",
        params: {app_name: appName},
    };
}

/**
 * `DELETE /api/v1/sessions/{session_id}?app_name=…`
 */
export function useDeleteSessionMutation() {
    return useMutation<DeleteSessionResponse, DefaultError, DeleteSessionVariables>({
        mutationFn: async (variables) => {
            if (environment.isTestChat) {
                return {message: "Test mode: delete session skipped"};
            }
            const {url, method = "DELETE", ...config} = deleteSessionMutationVariables(variables);
            const {data} = await queryHttp.request<DeleteSessionResponse>({url, method, ...config});
            return data;
        },
    });
}
